import Flex from 'components/Flex'
import Label from 'components/Form/Label'
import React, { useEffect, useState } from 'react'
import RichTextEditor from 'react-rte'
import styled from 'styled-components'
import { FONT } from 'theme/font'

const toolbarConfig = {
  display: [
    'INLINE_STYLE_BUTTONS',
    'BLOCK_TYPE_BUTTONS',
    'BLOCK_TYPE_DROPDOWN',
  ],
  INLINE_STYLE_BUTTONS: [
    { label: 'Bold', style: 'BOLD', className: 'header-button' },
    { label: 'Italic', style: 'ITALIC', className: 'header-button' },
    { label: 'Underline', style: 'UNDERLINE', className: 'header-button' },
  ],
  BLOCK_TYPE_DROPDOWN: [
    { label: 'Normal text', style: 'unstyled' },
    { label: 'Heading 1', style: 'header-one' },
    { label: 'Heading 2', style: 'header-two' },
    { label: 'Heading 3', style: 'header-three' },
  ],
  BLOCK_TYPE_BUTTONS: [
    {
      label: 'UL',
      style: 'unordered-list-item',
      className: 'header-button',
    },
    { label: 'OL', style: 'ordered-list-item', className: 'header-button' },
  ],
}
const StyledEditor = styled(RichTextEditor)`
  margin-top: 10px;
  font-family: ${FONT.FONT_FAMILY};
  height: auto;
  > div {
    background: #f9fafa;
  }
  .header-button {
    border: none;
  }
  .public-DraftEditor-content {
    min-height: ${props => (props.size == 'small' ? '50px' : '250px')};
    padding: 0px 9px 10px 9px;
  }
  .IconButton__icon___3YgOS {
    background-size: 22px;
    border-radius: 15px;
  }
  .DraftEditor-editorContainer {
    padding: 10px 0;
  }
  .EditorToolbar__root___3_Aqz {
    margin: 0;
    padding: 10px 5px;
  }
  .DraftEditor-root {
    background: #ffffff;
  }
`

const RichEditor = ({
  onChange,
  value = '',
  labelName = 'Job description *',
  placeholder = 'Enter job description here...',
  editText = false,
  isImportant = false,
  size = 'large',
  isCompanyDescription,
  setLengthError,
  ...rest
}) => {
  const [state, setState] = useState({
    description: value
      ? RichTextEditor.createValueFromString(value, 'html')
      : RichTextEditor.createEmptyValue(),
  })
  const [charCount, setCharCount] = useState(0)
  const [error, setError] = useState('')
  const stripHtmlTags = html => {
    const div = document.createElement('div')
    div.innerHTML = html
    return div.textContent || div.innerText || ''
  }
  const handleOnchange = (val, key) => {
    setState({ [key]: val })
    if (onChange) {
      onChange(val.toString('html'))
    }
  }
  useEffect(() => {
    setState({
      description: value
        ? RichTextEditor.createValueFromString(value, 'html')
        : RichTextEditor.createEmptyValue(),
    })
  }, [editText])
  useEffect(() => {
    if (isCompanyDescription) {
      const plainText = stripHtmlTags(state?.description?.toString('html'))
      const characterCount = plainText.length
      setCharCount(characterCount)
      if (characterCount > 2000) {
        setError('Character limit exceeded. Maximum 2000 characters allowed.')
        setLengthError(true)
      } else {
        setError('')
        setLengthError(false)
      }
    }
  }, [state])
  return (
    <div>
      <Flex centerVertically>
        <Label isImportant={isImportant}>{labelName}</Label>
      </Flex>
      <StyledEditor
        size={size}
        value={state.description}
        toolbarConfig={toolbarConfig}
        onChange={val => handleOnchange(val, 'description')}
        placeholder={placeholder}
        {...rest}
      />
      {isCompanyDescription && (
        <>
          <div
            style={{ display: 'flex', justifyContent: 'end', color: 'gray' }}
          >
            {' '}
            {charCount}/2000
          </div>
          {error && <div style={{ color: 'red' }}>{error}</div>}
        </>
      )}
    </div>
  )
}

export default RichEditor
